// extracted by mini-css-extract-plugin
module.exports = {"phenix-video-item":"phenix-video-player_phenix-video-item__DXNLp","controls":"phenix-video-player_controls__196X9","status":"phenix-video-player_status__1qtid"};